export default (state = {

}, { type, payload }) => {
	switch (type) {
		case 'SET_FORM_VALUES':
			return {
				...state,
				[payload.id]: payload.form,
				[payload.id + "_dirty"]: payload.dirty
			}
		case 'SET_FORM_DRAFT_LOADED':
			return {
				...state,
				[payload.id + "_draftLoaded"]: payload.draftLoaded
			}
		case 'CLEAR_FORM_VALUES':
			return {
				...state,
				[payload.id]: undefined,
				[payload.id + "_dirty"]: undefined,
				[payload.id + "_draftLoaded"]: undefined
			}
		default:
			return state
	}
}
